module.exports = __webpack_public_path__ + "static/media/OpenSans.9aa9bf08.woff2";